/**
 * TrueMed product-page widget loader.
 *
 * Loaded by blocks/truemed-widget.liquid. Injects TrueMed's vendor script
 * exactly once per page view.
 *
 * Why a guard at all: Horizon re-emits the block's markup through the section
 * rendering API on variant and selling-plan changes, so this file can be parsed
 * more than once in a single page view. The vendor script installs a
 * MutationObserver on `document` and re-hydrates `#truemed-instructions` by
 * itself, so a second copy would only double-bind that observer — it is never
 * needed.
 */
(function () {
  var FALLBACK_SRC = 'https://static.truemed.com/widgets/product-page-widget.min.js';

  // Deliberately narrower than `script[src*="truemed"]`: this very file is
  // served from the Shopify CDN as `truemed-widget.js`, which that broader
  // selector would match, and the guard would then never inject anything.
  var VENDOR_SELECTOR = 'script[src*="truemed.com"]';

  if (window.truemedScriptLoaded) return;

  if (document.querySelector(VENDOR_SELECTOR)) {
    window.truemedScriptLoaded = true;
    return;
  }

  var host = document.querySelector('[data-truemed-src]');
  if (!host) return;

  var script = document.createElement('script');
  script.src = host.getAttribute('data-truemed-src') || FALLBACK_SRC;
  script.async = true;
  // Matches the theme's other vendor tags (see snippets/beam-scripts.liquid).
  script.setAttribute('data-em-disable', '');

  // A failed load must not latch the flag, or a later section render has no way
  // to retry.
  script.addEventListener('error', function () {
    window.truemedScriptLoaded = false;
    script.remove();
  });

  window.truemedScriptLoaded = true;
  document.head.appendChild(script);
})();
